// Imports for external libraries go here.
import React, { FC } from 'react';
import clsx from 'clsx';

// Imports for internal (to the monorepo) libraries go here.
import { Heading, Link, Text, Types } from '@marriott/mi-ui-library';

export type WebPromptBannerContentProps = {
  title: string;
  subtitle: string;
  ctaLabel: string;
  ctaPath?: string;
  isExternalLink?: boolean;
  subtitleClassName?: string;
  onCtaClick?: (event: React.SyntheticEvent) => void;
};

export const WebPromptBannerContent: FC<WebPromptBannerContentProps> = ({
  title,
  subtitle,
  ctaLabel,
  ctaPath = '#',
  isExternalLink = false,
  subtitleClassName = 't-label-s',
  onCtaClick,
}) => {
  return (
    <div className="ml-3 ml-lg-4 mr-3 mr-md-4 mr-lg-0 content-wrapper" data-testid="webPromptBannerContent">
      <Heading
        variation={Types.headingType.subtitle}
        fontSize={Types.size.large}
        titleText={title}
        customClass="mb-1"
      />
      <div className={clsx('banner-content-description mb-1', subtitleClassName)}>{subtitle}</div>
      <Link
        linkClassName={clsx(isExternalLink ? 'm-link-tertiary-button-external' : 'm-link-tertiary-button')}
        target={isExternalLink ? '_blank' : '_self'}
        text={ctaLabel}
        linkHref={ctaPath}
        callback={onCtaClick}
        data-testid="webPromptBannerCta"
      />
    </div>
  );
};
